import Project from './index'
import options from './options.js'
import {
	logout
} from '../../store/router.js'
var pro = new Project(options);

//闲置时间超过后自动登出
pro._AutoLogin = new pro.base.AutoLogOut(logout);
pro._AutoLogin.start();
window.loop = () => {};

//更改默认的颜色
localStorage.removeItem('themColor');

export var install = function() {
	pro._name = "BH";
	if (window && !window[pro._name]) {
		window[pro._name] = pro;
	} else if (window) pro.warn(`
	${this._name}:
	window is undefined`)
}
install();
